import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraEmptyState, SpecraPageHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useMemo } from 'react';
import { useRfiRecord } from './RfiRecordContext';
import { TeamPanel } from './RfiTeamPanel';
import { useRfiAnswerSections } from './useRfiAnswerSections';
/** Team (WRT-07 page 8): the project team with questions owned per member. */ export function RfiTeamPage() {
    const record = useRfiRecord();
    const { sections } = useRfiAnswerSections(record?.pangaeaId ?? '');
    const owned = useMemo(()=>{
        const m = new Map();
        for (const s of sections){
            if (s.ownerUserId) m.set(s.ownerUserId, (m.get(s.ownerUserId) ?? 0) + 1);
        }
        return m;
    }, [
        sections
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-[var(--space-4)] p-[var(--space-6)]",
        "data-testid": Testids.rfiWorkspace.teamPage,
        children: [
            /*#__PURE__*/ _jsx(SpecraPageHeader, {
                title: "Team",
                titleSize: "ui"
            }),
            record?.zouProjectId ? /*#__PURE__*/ _jsx(TeamPanel, {
                ownedCounts: owned,
                zouProjectId: record.zouProjectId
            }) : /*#__PURE__*/ _jsx(SpecraEmptyState, {
                framed: true,
                title: "No team yet"
            })
        ]
    });
}
